import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { Button, Modal, Icon, Header, Divider } from 'semantic-ui-react';
import TargetLink from '../../components/target-link';

const modalStyle = {
  textAlign: 'center',
  color: '#777',
};

const nameStyle = {
  marginTop: 10,
  marginBottom: 10,
  display: 'block',
};

const redirectTo = (href, router) => {
  // eslint-disable-next-line lodash/prefer-lodash-method
  router.push(`/logout?redirect_uri=${href}`);
};

const OriginBasedLock = ({
  requiredOrigin,
  organisationName,
  router,
}) => (
  <Modal
    open
    style={modalStyle}
    size="small"
  >
    <Modal.Content>
      <Header as="h2" icon>
        <Icon name="warning sign" color="orange" />
        <h2 style={nameStyle}>{organisationName}</h2>
        <Header.Subheader>
            In order for the system to work properly you must login at  <TargetLink renderIf href={requiredOrigin}>{requiredOrigin}</TargetLink>
          <Divider />
          <Button color="pink" onClick={() => redirectTo(requiredOrigin, router)}>Go to {requiredOrigin}</Button>
        </Header.Subheader>
      </Header>
    </Modal.Content>
  </Modal>
);

OriginBasedLock.propTypes = {
  requiredOrigin: PropTypes.string.isRequired,
  organisationName: PropTypes.string.isRequired,
  router: PropTypes.object.isRequired,
};

export default withRouter(OriginBasedLock);



/** WEBPACK FOOTER **
 ** ./src/components/origin-based-lock/index.js
 **/